<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="-10 0 310 300">
    <path
      fill="currentColor"
      d="M38 19l-19 18v225l19 19h225l18 -19v-225l-18 -18h-225zM263 262h-188v-225h188v225z"
    />
  </svg>
</template>
